import { Modal } from 'antd';
import { useIntl } from 'react-intl';

function useDefaultDeleteModal(entityName: string) {
  const intl = useIntl();

  const handleDelete = (
    mutate: () => Promise<unknown>,
    onFinish: () => Promise<unknown>,
  ) => {
    Modal.confirm({
      title: intl.formatMessage({ id: `${entityName}.remove.confirm.title` }),
      content: intl.formatMessage({
        id: `${entityName}.remove.confirm.content`,
      }),
      onOk: async () => {
        await mutate();

        await onFinish();
      },
    });
  };

  return { handleDelete };
}

export default useDefaultDeleteModal;
